<template>
  <div>
    <data-table :service="CreditService"
                :entity="entity"
                :columns="columns"
                :go-to-details-on-row-click="false"
                :clickable="false"
                ref="table">

      <div class="d-flex align-items-center" slot="client" slot-scope="{row}">
        <base-avatar :name="row.clients">
        </base-avatar>
        <div class="ml-2 font-weight-bold">
          <router-link @click.native.stop="" :to="`/contacts/clients/${row.client_uuid}`">
            {{row.client}}
          </router-link>
        </div>
      </div>
      <template slot="credits" slot-scope="{row}">
        {{row.credits}}
      </template>
      <template slot="valid_till" slot-scope="{row}">
        {{$formatDate(row.valid_till, FRIENDLY_DATE_FORMAT)}}
      </template>

      <template slot="extra-buttons" slot-scope="{row}">
        <base-button @click.stop="onShow(row)" outline icon size="sm">
          <i class="fas fa-eye"></i>
        </base-button>
      </template>
    </data-table>
  </div>
</template>
<script>
  import CreditService from 'src/services/CreditService'
  import entities from 'src/config/entities'
  import { getRouteName } from 'src/config/routeTypes'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'credit-list',
    data () {
      return {
        FRIENDLY_DATE_FORMAT,
        CreditService,
        entity: entities.CREDIT
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'client',
            label: this.$t('credit.list.labels.client'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'credits',
            label: this.$t('credit.list.labels.credits'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'valid_till',
            label: this.$t('credit.list.labels.validTill'),
            minWidth: '150px',
            sortable: true
          }
        ]
      }
    },
    methods: {
      onShow (row) {
        this.$router.push({
          name: getRouteName('credits', entities.CLIENT), params: {
            id: row.client_uuid
          }
        })
      }
    }
  }
</script>
<style>
</style>
